export default __webpack_public_path__ + "static/media/no_location.e9600541.png";